import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
// /nom-bonic-programa/personatges/

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS, 'programa', 'personatges']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'personatges'];
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
